export class ColecaoIdsCesta {
	listaIdCestaCurriculo!: number[];
}
